import {File as FileT} from "platformed-client/types";

import StyledFile from "./StyledFile";
import {FileUploadBase} from "../../hooks/fileUpload";
import {useAsyncOperation} from "../../hooks/asyncOperation";
import {ReactNode, useCallback} from "react";

type FileUploaderProps = {
  fileUpload: FileUploadBase;
  onDelete: (fileUpload: FileUploadBase) => void;
  disabled?: boolean;
  /** Leading item in the row's meta line, before the file size. */
  label?: ReactNode;
};

export const UploadingFile = ({fileUpload, onDelete, disabled, label}: FileUploaderProps) => {
  const state = useAsyncOperation(fileUpload);
  const delete_ = useCallback(() => onDelete(fileUpload), [onDelete, fileUpload]);
  return (
    <StyledFile
      file={fileUpload.file}
      onDelete={delete_}
      progress={state.id === "Uploading" ? state.progress : undefined}
      error={state.id === "Error" ? state.error : undefined}
      disabled={disabled}
      label={label}
    />
  );
};

export const UploadedFile = ({file, onDelete}: {file: FileT; onDelete?: () => void}) => {
  return <StyledFile file={{type: file.mime_type, ...file}} onDelete={onDelete} />;
};
